import initVueApp from "@/core.js";
const component = require(`../views/RecursiveJSONTemplate.vue`).default;
initVueApp(component);
